import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FinanceService } from 'src/app/finance/finance.service';
import { GlobalService } from 'src/app/shared/services/global.service';

@Component({
    selector: 'app-catering-detail-files',
    templateUrl: './catering-detail-files.component.html',
    styleUrls: ['./catering-detail-files.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CateringDetailFilesComponent implements OnInit {

	@Input() catering: any;
	@Input() showProject: boolean = true;
	@Input() isShooting: boolean = false;
	@Input() project: any;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();
	@Output() onStatusChange = new EventEmitter<any>();

	loading: boolean = false;
	cateringFiles: any = [];
	selectedCatering: any;
	isUpdatingCatering: boolean = false;

	close() {
		this.closeView.emit()
	}

	update() {
		this.loadCatering(true);
	}

	loadCatering(isUpdate?) {
		this.loading = true;
		let projectId = this.project ? this.project.id : this.catering.project_id;
		this._fiS.getCateringDetail(this.catering.id, projectId).subscribe(
			(data: any) => {
				this.cateringFiles = data.files;
				this.selectedCatering = data.caterings;
				this.selectedCatering.total_cost = this.selectedCatering.quantity * this.selectedCatering.cost_unit;
				// if (isUpdate) {
				// 	this.notify.emit();
				// }
				this.loading = false;
			}
		)
	}

	changeCateringStatus(newStatus) {
		this.loading = true;
		this._fiS.changeCateringStatus(this.catering.id, newStatus).subscribe(
			data => {
				this.setUpdatingText();
				this.isUpdatingCatering = true;
				this.onStatusChange.emit();
				this.loading = false;
			}
		);
	}

	setUpdatingText() {
		this.selectedCatering.se_st_name_eng = 'updating';
		this.selectedCatering.se_st_name_esp = 'actualizando';
		this.catering.se_st_name_eng = 'updating';
		this.catering.se_st_name_esp = 'actualizando';
		this._cD.detectChanges();
	}

	constructor(private _cD: ChangeDetectorRef, public _gS: GlobalService, private _fiS: FinanceService) { }

	ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.catering) {
			this.loadCatering();
			this.isUpdatingCatering = false;
		}
	}

}
